angular.module('dpw.services')

    .factory('editProfileUtils', ['api', 'myAccountUtils', function (api, myAccountUtils) {
        return {

            /**
             * Fetch the profile of user who has already logged in.
             *
             * @param {Function} onSuccess - Execute if it succeeds to fetch the profile.
             * @param {Function} [onError] - Execute if it fails to fetch the profile.
             */
            fetchProfile: function (onSuccess, onError) {
                myAccountUtils.getDevelopers({
                    onSuccess: onSuccess,
                    onError: onError
                });
            },

            /**
             * Submit changes of a user profile to the server.
             *
             * @param {Object} profile - User profile which contains changes.
             * @param {Function} onSuccess - Execute if it succeeds to update the profile.
             * @param {Function} onError - Execute if it fails to update the profile.
             */
            updateProfile: function (profile, onSuccess, onError) {
                api.call(api.myAccount.developers.update(profile), onSuccess, onError);
            },

            /**
             * Submit a request for password changing to the server.
             *
             * @param {Object} profile - Object containing old password and new password.
             * @param {Function} onSuccess - Execute if it succeeds to change the password.
             * @param {Function} onError - Execute if it fails to change the password.
             */
            changePassword: function (profile, onSuccess, onError) {
                api.call(api.myAccount.developers.changePassword(profile), onSuccess, onError);
            },

            /**
             * Adapter between different requirements of format for profile objects.
             *
             * @param {Object} profile - A profile object to be adapted.
             * @param {Object} [options] - Rule definitions for the adaption.
             * @param {Array<String>} [options.neededFields] - A set of key names which will be kept in the profile object.
             * @param {Object} [options.keyNameAlias] - Rules for the key name adaption in the profile object.
             *
             * @returns {Object} An adapted profile object.
             */
            profileAdapter: function (profile, options) {
                options = options || {};
                var neededFields = options.neededFields;
                var keyNameAlias = options.keyNameAlias;

                if (neededFields) {
                    profile = _.pick(profile, neededFields);
                    _.forEach(neededFields, function (keyName) {
                        profile[keyName] = profile[keyName] || '';
                    });
                }

                _.forEach(keyNameAlias, function (alias, keyName) {
                    profile[alias] = profile[keyName];
                    delete profile[keyName];
                });

                return profile;
            },

            /**
             * Extract the error handler configuration from each field configuration object.
             *
             * @param {Object} fieldsConfig - Configuration object for fields in a form.
             * @returns {Object} Configuration for the error handler.
             */
            extractHandlerConfig: function (fieldsConfig) {
                var result = {};

                _.forEach(fieldsConfig, function (fieldConfig) {
                    var errorHandler = fieldConfig.errorHandler;
                    if (errorHandler) {
                        _.forEach(errorHandler, function (item) {
                            result[item.code] = _.bind(item.action, null, fieldConfig, item.code);
                        });
                    }
                });

                return result;
            },

            /**
             * Change Email Address - Submit a new email address and request for verification code
             *
             * @param {Object} data
             * @param {String} data.email               - New email address
             * @param {String} data.password            - Password for the current account
             * @param {String} data.googleRecaptcha     - Response data generated by Google reCAPTCHA
             * @param {Function} onSuccess
             * @param {Function} onError
             */
            confirmNewEmail: function (data, onSuccess, onError) {
                api.call(api.myAccount.developers.changeEmail.sendCode(data), onSuccess, onError);
            },

            /**
             * Change Email Address - Request for a new verification code
             */
            resendCode: function (onSuccess, onError) {
                api.call(api.myAccount.developers.changeEmail.resendCode(), onSuccess, onError);
            },

            /**
             * Change Email Address - Submit the verification code to complete the changing of email address
             *
             * @param {Object} data
             * @param {String} data.verificationCode
             * @param {Function} onSuccess
             * @param {Function} onError
             */
            updateEmail: function (data, onSuccess, onError) {
                api.call(api.myAccount.developers.changeEmail.updateEmail(data), onSuccess, onError);
            }

        };
    }])

;